module.exports = __webpack_public_path__ + "img/2012-08-18 09.14.39.7d093ef4.jpg";